export default __webpack_public_path__ + "static/media/calendar.2a705b1e.svg";